import React from 'react';
import { Checkbox, Divider, Radio, Space } from 'antd';

import WizardContentBox from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardContentBox';
import WizardTitle from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardTitle';
import { WizardDescription } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardDescription';
import WizardQuestionHelp from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardQuestionHelp';
import { HELP_CONTENT } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/config/stepConstants';
import useWizard from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/context/useWizard';

const AdultBeverageStep = ({ step }) => {
  const { state, actions } = useWizard();

  const { content, field } = step;
  const isYes = state.answers[field];
  const { beer, wine, spirits } = state.answers;

  const handleYesNoChange = (e) => {
    actions.setAnswer(field, e.target.value);

    // Clear sub-selections when switching to No
    if (!e.target.value) {
      actions.setAnswer('beer', false);
      actions.setAnswer('wine', false);
      actions.setAnswer('spirits', false);
    }
  };

  const handleCheckboxChange = (checkboxField) => (e) => {
    actions.setAnswer(checkboxField, e.target.checked);
  };

  return (
    <WizardContentBox>
      <WizardTitle title={content.title} />
      <Divider />
      <div className='wizard-question-rows'>
        <div className='wizard-question-row wizard-question-row--adult-beverage'>
          <WizardDescription>{content.question}</WizardDescription>
          <Radio.Group value={isYes} onChange={handleYesNoChange}>
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
          {isYes === true && (
            <>
              <WizardDescription>Beer, Wine or Spirits?</WizardDescription>
              <Space direction='horizontal' size='small' align='baseline' wrap>
                <Checkbox checked={beer} onChange={handleCheckboxChange('beer')}>
                  Beer
                </Checkbox>
                <Checkbox checked={wine} onChange={handleCheckboxChange('wine')}>
                  Wine
                </Checkbox>
                <Checkbox
                  checked={spirits}
                  onChange={handleCheckboxChange('spirits')}
                >
                  Spirits
                </Checkbox>
              </Space>
            </>
          )}
        </div>
      </div>
      <WizardQuestionHelp
        help={step.help || HELP_CONTENT.alcoholic}
        stepKey='alcoholic'
      />
    </WizardContentBox>
  );
};

export default AdultBeverageStep;
